import { render } from "./ViewStory.vue?vue&type=template&id=01daf631&scoped=true&ts=true"
import script from "./ViewStory.vue?vue&type=script&lang=ts"
export * from "./ViewStory.vue?vue&type=script&lang=ts"

import "./ViewStory.vue?vue&type=style&index=0&id=01daf631&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01daf631"]])

export default __exports__